var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50.001,
    viewBox: "0 0 50 50.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M50.459-104.833a25,25,0,0,1-25,25,25,25,0,0,1-25-25,25,25,0,0,1,25-25,25,25,0,0,1,25,25",
    transform: "translate(-0.459 129.833)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M59.479-94.775c0,7.439-4.354,13.47-9.725,13.47s-9.725-6.03-9.725-13.47,4.354-13.47,9.725-13.47,9.725,6.031,9.725,13.47",
    transform: "translate(-40.028 108.245)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M32.6-40.69c-8.14,0-15.418,1.951-20.258,5.016A24.963,24.963,0,0,0,32.757-25.1,24.962,24.962,0,0,0,53.073-35.539C48.234-38.682,40.863-40.69,32.6-40.69",
    transform: "translate(-12.346 40.69)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M58.438-49.193H55.476a3.726,3.726,0,0,1-3.715-3.715v-8.445a3.726,3.726,0,0,1,3.715-3.715h2.962a3.726,3.726,0,0,1,3.715,3.715v8.445a3.726,3.726,0,0,1-3.715,3.715",
    transform: "translate(-51.761 65.069)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M38.788-77.171c.291,2.16-.188,4.032-1.071,4.182s-1.834-1.479-2.125-3.638.188-4.032,1.071-4.182,1.834,1.479,2.125,3.638",
    transform: "translate(-35.506 80.819)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M86.3-77.171c-.291,2.16.188,4.032,1.071,4.182s1.834-1.479,2.125-3.638-.188-4.032-1.071-4.182S86.593-79.33,86.3-77.171",
    transform: "translate(-86.216 80.819)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M39.148-97.01q-.49-3.234-.981-6.469a4.608,4.608,0,0,1,.052-2.346,1.584,1.584,0,0,1,1.866-1.049c-.3-1.5,1.363-2.608,2.809-3.106a16.781,16.781,0,0,1,7.563-.93,10.936,10.936,0,0,1,6.736,3.358,5.99,5.99,0,0,1,1.268,2.057,8.887,8.887,0,0,1-.14,4.621q-.382,1.82-.764,3.641a1.626,1.626,0,0,1-.312.779,1.649,1.649,0,0,1-1.262.362l-14.467.031c-.907,0-2.09-.221-2.21-1.12",
    transform: "translate(-38.04 111.021)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "male-50px",
    transform: "translate(-0.459 129.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0.459 -129.833)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M-.541-130.833H50.231v50.772H-.541Z",
    transform: "translate(0.155 130.447)",
    fill: "#b4bdd3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(15.734 -121.5)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M39.028-109.245H59.251v27.712H39.028Z",
    transform: "translate(-39.414 108.859)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(5.048 -95.422)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M11.346-41.69h41.5v16.361h-41.5Z",
    transform: "translate(-11.732 41.304)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(20.263 -104.833)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M50.761-66.069H61.926v16.648H50.761Z",
    transform: "translate(-51.147 65.683)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(13.988 -110.912)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M33.972-82.183h4.551v8.893H33.972Z",
    transform: "translate(-34.564 81.656)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(33.563 -110.912)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M84.683-82.183h4.55v8.893h-4.55Z",
    transform: "translate(-85.275 81.656)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(14.966 -122.571)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M36.763-112.584h21.8v15.952h-21.8Z",
    transform: "translate(-37.256 111.981)",
    fill: "#fffefe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.ae58780b42001a4bdd2dbdf3b103fc63.svg";
export { ForwardRef as ReactComponent };